// @ts-strict-ignore
import React from 'react';

import { FourArticlesHighlightBlockData } from 'api/cms';
import { AmpCardsBlock } from 'cms/blocks/Amp/AmpCardsBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpFourArticlesHighlightBlock({
  content,
  blockId,
  data,
}: AmpBlockMappingComponentProps<FourArticlesHighlightBlockData>) {
  return (
    <AmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        headline: data.headline,
        cards: ['One', 'Two', 'Three', 'Four']
          .filter((page) => data[`page${page}`])
          .map((page) => ({
            image: data[`page${page}`].image,
            headline: data[`page${page}`].title,
            url: data[`page${page}`].url,
          })),
        maxLength: 4,
      }}
    />
  );
}
